export const SET_EMAIL = 'set-email';
export const SET_DATE = 'set-date';
export const SET_WEEK = 'set-week';
export const SET_PAGE_NUMBER = 'set-page-number';
export const SET_YEAR_MONTH = 'set-year-month';
export const TIMESHEET_NEXT = 'timesheet-next';
export const TIMESHEET_PREV = 'timesheet-prev';
export const SET_FILTERS = 'set-filters';
export const SET_PAGE_SIZE = 'set-page-size';
export const SET_YEAR = 'set-year';
export const TIMESHEET_PREV_YEAR = 'timesheet-prev-year';
export const TIMESHEET_NEXT_YEAR = 'timesheet-next-year';
